import { memo, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import { SidePane, useLayoutContext } from '@library';
import { useProductDetailsQuery } from '../../../queries/useProductDetails';
import { FluidProgressIndicator } from '../../../../core/components/ProgressIndicators';
import FalseDataForm from './FalseDataForm';
import styles from './ProductFalseDataModal.module.scss';

interface ProductFalseDataModalProps {
    onClose: () => void;
    openSuccessModal: () => void;
    open: boolean;
}

const ProductFalseDataModal = ({
    onClose = () => {},
    open,
    openSuccessModal = () => {},
}: ProductFalseDataModalProps) => {
    const { variantId, pid } = useParams<{
        pid: string;
        variantId?: string;
    }>();
    const { data, error } = useProductDetailsQuery({ id: pid });
    const product = data?.product;

    const selectedSKU = useMemo(() => {
        return (
            product?.variants.find(variant => variant.id === variantId)?.sku ??
            product?.sku
        );
    }, [variantId, product?.variants, product?.sku]);

    const content = product ? (
        <FalseDataForm
            openSuccessModal={openSuccessModal}
            product={product}
            selectedSku={selectedSKU}
            onClose={onClose}
        />
    ) : (
        <FluidProgressIndicator />
    );

    const { isInMobileView } = useLayoutContext();

    if (error) {
        throw error;
    }

    return (
        <SidePane
            open={open}
            onOpenChange={onClose}
            side={isInMobileView ? 'bottom' : 'right'}
            header={<FormattedMessage id="report incorrect data" />}
        >
            <div className={styles.content}>{content}</div>
        </SidePane>
    );
};

export default memo(ProductFalseDataModal);
